window.okeReviewsWidgetOnInit = function () {
	setupAggregateSection();
};

function setupAggregateSection() {
    // Move aggregate section into header
    var destination = document.querySelector(".okeReviews-reviewsWidget-header");
    var aggregateSection = document.querySelector(".okeReviews-reviewsAggregate-summary");
    if (destination && aggregateSection) {
        destination.insertAdjacentElement('afterend', aggregateSection);
     	aggregateSection.style.visibility= "visible";
    }
}